import { render, staticRenderFns } from "./HomeProductsList.vue?vue&type=template&id=9cf7ade6&scoped=true"
import script from "./HomeProductsList.vue?vue&type=script&lang=js"
export * from "./HomeProductsList.vue?vue&type=script&lang=js"
import style0 from "./HomeProductsList.vue?vue&type=style&index=0&id=9cf7ade6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cf7ade6",
  null
  
)

export default component.exports